import { api } from "../../../services/api";

/**
 * A12: rewired from the retired owner-scoped `/api/admin/addresses`
 * routes to the new global `/api/addresses` pool. Backend sets
 * `created_by` from the JWT — no owner id in the create body.
 */
const BASE = "/addresses";

export const adminAddressesService = {
  list: async (params) => (await api.get(BASE, { params })).data,
  create: async (payload) => (await api.post(BASE, payload)).data,
  update: async (addressId, payload) =>
    (await api.patch(`${BASE}/${addressId}`, payload)).data,
  remove: async (addressId) =>
    (await api.delete(`${BASE}/${addressId}`)).status,
};
